import logo from "./logo.svg";
import "./App.css";
import "../src/Assets/css/style.css";
import Publicroutes from "./routes/Publicroutes";
import $ from "jquery";
import { useEffect } from "react";

function App() {
  return (
    <>
      <Publicroutes />
    </>
  );
}

export default App;
